import { rest } from 'services'
import { withTireSizeInners } from 'components/VehicleConfigurator'

const {
  actions: { setValues },
  constants: { FRONT, REAR }
} = withTireSizeInners

export const initialize = ({ isModal }) => async dispatch => {
  try {
    const {
      tireSizes: {
        type,
        tireSize = []
      } = {}
    } = await rest.api.customTireSize({})

    dispatch(setValues({ position: FRONT, name: type, value: tireSize, isModal }))
    dispatch(setValues({ position: REAR, name: type, value: tireSize, isModal }))
  } catch (err) {
    console.error(err)
  }
}
